import { render, staticRenderFns } from "./DeepLinkButton.vue?vue&type=template&id=3f5827ad&scoped=true"
import script from "./DeepLinkButton.vue?vue&type=script&lang=js"
export * from "./DeepLinkButton.vue?vue&type=script&lang=js"
import style0 from "./DeepLinkButton.vue?vue&type=style&index=0&id=3f5827ad&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3f5827ad",
  null
  
)

export default component.exports